import Skeleton from "react-loading-skeleton";

import Box from "ds/components/Box";
import TileWrapper from "ds/components/Tile/Wrapper";
import TileContent from "ds/components/Tile/Content";

import styles from "./styles.module.css";

const AssistantPanelLearnGroupsViewSkeletonTile = () => (
  <TileWrapper className={styles.tile} fullWidth grow="0">
    <TileContent gap="small">
      <Box align="center" fullWidth justify="between">
        <Box align="center" gap="medium">
          <Skeleton width={36} height={36} borderRadius={8} />
          <Box direction="column" gap="small">
            <Skeleton width={120} height={16} borderRadius={4} />
            <Box direction="row" align="center" gap="small">
              <Skeleton width={16} height={16} borderRadius={4} />
              <Skeleton width={80} height={14} borderRadius={4} />
            </Box>
          </Box>
        </Box>
        <Skeleton width={16} height={16} borderRadius={4} />
      </Box>
    </TileContent>
  </TileWrapper>
);

const AssistantPanelLearnGroupsViewSkeleton = () => (
  <Box direction="column" padding="x-large" gap="large" grow="1" overflowHidden>
    <Box direction="column" gap="large">
      <Skeleton width="100%" height={16} borderRadius={4} />
      <Skeleton width="100%" height={8} borderRadius={4} />
    </Box>

    <Box direction="column" gap="medium" grow="1">
      {Array.from({ length: 4 }).map((_, index) => (
        <AssistantPanelLearnGroupsViewSkeletonTile key={index} />
      ))}
    </Box>
  </Box>
);

export default AssistantPanelLearnGroupsViewSkeleton;
